module.exports = __webpack_public_path__ + "static/media/releas.7490af3f.svg";